/*
 * @Author: your name
 * @Date: 2021-01-07 09:54:44
 * @LastEditTime: 2021-01-10 20:59:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\new\common\httpRequest\loading\loading.js
 */
import Vue from 'vue'
import Loading from './loadingTemplate.vue'

const LoadingConstructor = Vue.extend(Loading)

const loadingDOM = new LoadingConstructor({
  el: document.createElement('div'),
  data () {
    return {
      isShow: false,
      readyToClose: false,
      text: ''
    }
  }
})

document.body.appendChild(loadingDOM.$el)

export default function controlLoading (type = 'close') {
  switch (type) {
    case 'loading':
      loadingDOM.readyToClose = false
      setTimeout(function () {
        if (!loadingDOM.readyToClose) {
          loadingDOM.text = '加载中......'
          loadingDOM.isShow = true
          loadingDOM.readyToClose = false
        }
      }, 500)
      break
    case 'overtime':
      loadingDOM.text = '链接超时......'
      loadingDOM.isShow = true
      setTimeout(function () {
        loadingDOM.text = ''
        loadingDOM.isShow = false
        loadingDOM.readyToClose = false
      }, 2000)
      break
    case 'close':
      loadingDOM.readyToClose = true
      setTimeout(function () {
        loadingDOM.text = ''
        loadingDOM.isShow = false
      }, 500)
      break
    default:
      loadingDOM.readyToClose = false
      setTimeout(function () {
        loadingDOM.text = ''
        loadingDOM.isShow = false
      }, 500)
      break
  }
}
